import React from "react";

import { Divider, Header, Placeholder, SummaryLayout } from "..";

function SummaryPlaceholder() {
  return (
    <div data-test="summary-loader">
      <SummaryLayout>
        <Header as="h3">Current Subscription</Header>
        <Placeholder style={{ marginTop: "2em" }}>
          <Placeholder.Header>
            <Placeholder.Line length="medium" />
            <Placeholder.Line length="short" />
          </Placeholder.Header>
        </Placeholder>
        <Divider />
        <Header as="h3">Updated Subscription</Header>
        <Placeholder style={{ marginTop: "2em" }}>
          <Placeholder.Header>
            <Placeholder.Line length="medium" />
            <Placeholder.Line length="short" />
          </Placeholder.Header>
        </Placeholder>
        <Placeholder style={{ marginTop: "2em" }}>
          <Placeholder.Header>
            <Placeholder.Line />
            <Placeholder.Line />

            <Placeholder.Line />
            <Placeholder.Line length="medium" />
            <Placeholder.Line />
            <Placeholder.Line length="short" />
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
        <Divider />
        <Placeholder style={{ marginTop: "2em" }}>
          <Placeholder.Header>
            <Placeholder.Line length="full" />
            <Placeholder.Line />
          </Placeholder.Header>
        </Placeholder>
      </SummaryLayout>
    </div>
  );
}

export default SummaryPlaceholder;
